import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useFormStore } from '../stores/form';
export default {
  __name: 'lidmaatschap',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $axios = _useNuxtApp.$axios,
      $gtm = _useNuxtApp.$gtm,
      $sentry = _useNuxtApp.$sentry;
    var _useNavigation = useNavigation(),
      nextStep = _useNavigation.nextStep;
    var store = useFormStore();
    var router = useRouter();
    var route = useRoute();
    var clubMembership = ref(null);
    var clubMembershipOptions = ref([]);
    var actionPresentForClub = computed(function () {
      return store.membershipType.firstPeriodPromotion !== null || store.membershipType.secondPeriodPromotion !== null;
    });
    var isSelected = function isSelected(type) {
      if (store.membershipType.membership.type === type || store.membershipType.duration === type) {
        return true;
      }
      return false;
    };
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _route$query$club;
      var clubId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            store.abTest = true;
            clubId = (_route$query$club = route.query.club) !== null && _route$query$club !== void 0 ? _route$query$club : store.gym.id;
            _context.next = 4;
            return $axios.get("/clubs/".concat(clubId)).then(function (res) {
              $axios.get("/clubs/".concat(clubId, "/addons")).then(function (res) {
                if (res.data.length === 0) {
                  store.clubHasAddons = false;
                  return;
                }
                store.clubHasAddons = true;
              }).catch(function (error) {
                $sentry.captureException(error);
              });
              var club = {
                id: res.data.id,
                name: res.data.name,
                city: res.data.city,
                youTubeUrl: res.data.youTubeUrl,
                homeProgramUrl: res.data.homeProgramUrl,
                isCefEnabled: res.data.isCefEnabled,
                promotion: res.data.promotion,
                appointmentModuleEnabled: res.data.appointmentModuleEnabled,
                appointmentFrameUrl: res.data.appointmentFrameUrl
              };
              if (route.query.club) {
                $gtm.push({
                  event: 'selected_club',
                  club: club
                });
              }
              store.gym = club;
              store.steps.gym = true;
            }).catch(function (_) {
              store.resetGym();
              store.resetMembershipAndAddons();
              store.resetSteps();
              router.push('/');
            });
          case 4:
            if (store.gym.id) {
              $axios.get("/clubs/".concat(store.gym.id, "/club-membership")).then(function (res) {
                clubMembership.value = res.data;
                clubMembership.value[0].clubMembershipOptions.forEach(function (option) {
                  return clubMembershipOptions.value.push(option.name);
                });
                if (!store.membershipType.membership.type) {
                  changeSelectedType({
                    id: 'adult'
                  });
                  membershipSelected('secondPeriod');
                }
              }).catch(function (error) {
                $sentry.captureException(error);
                store.resetGym();
                store.resetMembershipAndAddons();
                store.resetSteps();
                router.push('/');
              });
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var changeSelectedType = function changeSelectedType(event) {
      var _clubMembership$value;
      triggerElementClicked("subscription_selector_".concat(event.id));
      var selectedMembershipData = (_clubMembership$value = clubMembership.value) === null || _clubMembership$value === void 0 ? void 0 : _clubMembership$value.find(function (item) {
        return item.membership.type === event.id;
      });
      if (selectedMembershipData) {
        store.membershipType = _objectSpread({
          duration: null
        }, selectedMembershipData);
        membershipSelected('secondPeriod');
      }
    };
    var membershipSelected = function membershipSelected(durationType) {
      var _clubMembership$value2;
      if (!store.membershipType.membership.type) {
        return;
      }
      var selectedMembershipData = (_clubMembership$value2 = clubMembership.value) === null || _clubMembership$value2 === void 0 ? void 0 : _clubMembership$value2.find(function (item) {
        return item.membership.type === store.membershipType.membership.type;
      });
      var accessKey = selectedMembershipData.clubMembershipOptions.find(function (item) {
        return item.name === 'Toegangssleutel';
      });
      var registrationFee = selectedMembershipData.clubMembershipOptions.find(function (item) {
        return item.name === 'Inschrijfgeld';
      });
      var monthlyPrice;
      var accessKeyPrice;
      var registrationFeePrice;
      var promotion;
      if (durationType === 'firstPeriod') {
        monthlyPrice = selectedMembershipData.firstPeriodPrice;
        accessKeyPrice = accessKey.firstPeriodValue;
        registrationFeePrice = registrationFee.firstPeriodValue;
        promotion = selectedMembershipData.firstPeriodPromotion;
      }
      if (durationType === 'secondPeriod') {
        monthlyPrice = selectedMembershipData.secondPeriodPrice;
        accessKeyPrice = accessKey.secondPeriodValue;
        registrationFeePrice = registrationFee.secondPeriodValue;
        promotion = selectedMembershipData.secondPeriodPromotion;
      }
      store.membershipType = _objectSpread(_objectSpread({
        type: store.membershipType.id,
        duration: durationType
      }, selectedMembershipData), {}, {
        monthlyPrice: monthlyPrice,
        accessKeyPrice: accessKeyPrice,
        registrationFeePrice: registrationFeePrice,
        promotion: promotion
      });
      store.summary = {
        monthlyPrice: monthlyPrice,
        membershipType: {
          membership: {
            type: store.membershipType.membership.type
          }
        }
      };
    };
    function subscribeNextStep(durationType) {
      membershipSelected(durationType);
      nextStep(route.name);
    }
    function optionsPerPeriod(period) {
      var options = [];
      var periodValue = period === 'first' ? 'firstPeriodValue' : 'secondPeriodValue';
      store.membershipType.clubMembershipOptions.forEach(function (option) {
        if (option[periodValue] === 'true' || option.name === 'Toegangssleutel' || option.name === 'Inschrijfgeld') {
          options.push(option);
        }
      });
      return options;
    }
    function triggerElementClicked(element) {
      $gtm.push({
        event: 'clicked_element',
        element: "ab_".concat(element)
      });
    }
    return {
      __sfc: true,
      $axios: $axios,
      $gtm: $gtm,
      $sentry: $sentry,
      nextStep: nextStep,
      store: store,
      router: router,
      route: route,
      clubMembership: clubMembership,
      clubMembershipOptions: clubMembershipOptions,
      actionPresentForClub: actionPresentForClub,
      isSelected: isSelected,
      changeSelectedType: changeSelectedType,
      membershipSelected: membershipSelected,
      subscribeNextStep: subscribeNextStep,
      optionsPerPeriod: optionsPerPeriod,
      triggerElementClicked: triggerElementClicked
    };
  }
};